/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { IconBaseProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconBeta12 = forwardRef<SVGSVGElement, IconBaseProps>(function IconBeta12(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 12 12" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.17 2.632c-.178.343-.17.825-.17 1.036v3.679l.002.002c.049.066.13.159.248.253.23.185.671.498 1.3.498 1.017 0 1.462-.796 1.462-1.561 0-.374-.15-.79-.445-1.061-.294-.271-.786-.492-1.565-.492v-.807c.798 0 1.215-.185 1.428-.315.213-.13.657-.468.545-1.164-.112-.696-.878-.994-1.541-.906-.664.088-1.059.445-1.264.838ZM7.43 4.54c.137-.046.525-.188.724-.326.198-.139.677-.414.736-1.262.058-.848-.775-2.028-2.52-1.948-1.108.05-1.77.692-2.05 1.16-.287.468-.32 1.09-.32 1.504V11h1V8.288c.25.203.816.709 1.618.709.654 0 1.274-.227 1.732-.709C8.823 7.79 9 7.2 9 6.538c0-.626-.22-1.124-.781-1.553-.27-.205-.512-.289-.789-.364v-.08Z"
                fill="#D00"
            />
        </SVGContainer>
    );
});

const IconBeta16 = forwardRef<SVGSVGElement, IconBaseProps>(function IconBeta16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.405 3.959c-.215.41-.205.99-.205 1.243v4.414l.002.003c.059.079.156.19.298.304.276.221.806.597 1.56.597 1.22 0 1.754-.955 1.754-1.874 0-.448-.18-.946-.533-1.272-.353-.326-.944-.591-1.879-.591v-.968c.957 0 1.458-.222 1.714-.378s.788-.562.654-1.397-1.053-1.193-1.85-1.087c-.796.105-1.27.534-1.515 1.006Zm2.711 2.29c.165-.056.63-.227.868-.393.239-.166.813-.496.884-1.514.07-1.017-.93-2.433-3.025-2.337-1.329.06-2.123.83-2.459 1.392C5.04 3.96 5 4.706 5 5.202V14h1.2v-3.254c.3.243.98.85 1.941.85.785 0 1.53-.272 2.079-.85.568-.598.779-1.307.779-2.1 0-.751-.264-1.35-.937-1.863-.323-.248-.614-.347-.946-.437v-.098Z"
                fill="#D00"
            />
        </SVGContainer>
    );
});

const IconBeta24 = forwardRef<SVGSVGElement, IconBaseProps>(function IconBeta24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.607 5.938c-.321.617-.307 1.485-.307 1.865v6.622l.003.003c.088.119.234.286.447.456.414.332 1.209.895 2.34.895 1.83 0 2.631-1.431 2.631-2.81 0-.672-.27-1.42-.8-1.909-.53-.488-1.415-.886-2.818-.886V8.723c1.436 0 2.187-.334 2.571-.568.384-.233 1.182-.843.98-2.095-.2-1.252-1.579-1.789-2.773-1.63-1.194.157-1.905.8-2.274 1.508Zm4.067 3.434c.247-.083.945-.338 1.302-.588.358-.249 1.22-.744 1.325-2.27.106-1.527-1.394-3.65-4.536-3.507-1.993.09-3.185 1.246-3.688 2.089-.518.842-.577 1.963-.577 2.707V21h1.8v-4.881c.45.364 1.47 1.276 2.912 1.276 1.178 0 2.294-.409 3.118-1.276.852-.897 1.168-1.96 1.168-3.15 0-1.127-.396-2.024-1.404-2.795-.485-.37-.921-.52-1.42-.655v-.147Z"
                fill="#D00"
            />
        </SVGContainer>
    );
});

export const IconBeta = forwardRef<SVGSVGElement, IconBaseProps>(function IconBeta(props, ref) {
    const { size = '16' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
    } as const;

    switch (size) {
        case '12':
            return <IconBeta12 {...iconProps} />;
        case '16':
            return <IconBeta16 {...iconProps} />;
        case '24':
            return <IconBeta24 {...iconProps} />;
        default:
            return <IconBeta24 {...iconProps} />;
    }
});
